import 'gsap';
import 'gsap/ScrollToPlugin';
import './lib/polyfills';
import Sharer from './modules/Sharer';
import Tracking from './modules/Tracking';
import lazySizes from './lib/lazysizes';
import Viewport from './tools/Viewport';
import Components from './components/Index';
import './components/HeroDefault';

const init = () => {
    Viewport.init();
    // Viewport.addTabbableSelectors('.flickity-enabled');
    Viewport.releaseTabbing();
    Components.init();
    lazySizes.init();
    Sharer.init();
    Tracking.init();
};

require('doc-ready')(() => {
    init();
});
